var currenciesEnum = {
    Unknown : 0,
    Coins : 1,

};
var currencies = Object.keys(currenciesEnum).map((key) => { return {n: key, v: currenciesEnum[key]}});

export {
    currencies
};